import { render } from "./VTextFieldExternal.vue?vue&type=template&id=a156d6e8"
import script from "./VTextFieldExternal.vue?vue&type=script&lang=js"
export * from "./VTextFieldExternal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__